/**
 * What: Lifecycle declaration for existing-account sign-in from Shopify.
 * Transport / data-flow: Pure action declaration; the browser opens a signed Web handoff on demand.
 * Invariants: Signing in is separate from permission to connect; Web owns all admission checks.
 */
import { launchAdmissionCopy } from '@testfeed/product-language'
import { definePage } from '../page-declaration'

/** No eligibility read is needed to offer sign-in; the handoff remains an exclusive explicit action. */
export const page = definePage({
  name: 'launch-admission',
  sources: {},
  actions: {
    connect: {
      saves: false,
      interaction: { textEditing: 'block' },
      feedback: { failure: launchAdmissionCopy.failed },
    },
  },
})
